import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close2",
  "use": "icon-close2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close2\"><path d=\"M567.68 511.915L822.485 257.28a39.253 39.253 0 0 0 0-55.595 39.253 39.253 0 0 0-55.594 0L512 456.192 257.11 201.6a39.253 39.253 0 0 0-55.595 0 39.253 39.253 0 0 0 0 55.595L456.32 511.787l-254.805 254.72a39.253 39.253 0 0 0 27.776 67.072c10.112 0 20.096-3.798 27.818-11.478L512 567.51l254.89 254.72c7.68 7.68 17.707 11.478 27.82 11.478a39.253 39.253 0 0 0 27.818-67.115L567.68 511.872z\" p-id=\"1686\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/close2.svg
// module id = E7Nu
// module chunks = 2